
<div class="sk-cms-mimage-text"
    {{if style.background.styleType != 'default'}}
        {{if style.background.backgroundType == 'color'}}
            style="background-color:{{style.background.color}}"
        {{/if}}
        {{if style.background.backgroundType == 'img'}}
            style="background-image:url('{{style.background.imgUrl}}')"
        {{/if}}
    {{/if}}
>

    {{if style.isShowTitle == '1'}}
        <% include('../common/title.art', {title: basic.title, terminal: 'title-wap'}) %>
    {{/if}}

    {{if !content.items || !content.items.length}}
         <% include('../common/nodata.art') %>
    {{else}}
    {{if style.moreStyle.styleType != 'hide' && isMain != 1}}
    <div class="sk-cms-more-wap">

            <div class="more sk-cms-more-dom">
                {{if isDesign}}
                    <span class="more-btn {{style.moreStyle.styleType == 'default'?'medium':style.moreStyle.fontSize}}" style="{{style.moreStyle.styleType == 'default' ? '': 'color:' + style.moreStyle.color}}">MORE >></span>
                {{else}}
                    <a class="more-btn goto-link {{style.moreStyle.styleType == 'default'?'medium':style.moreStyle.fontSize}}" style="{{style.moreStyle.styleType == 'default' ? '': 'color:' + style.moreStyle.color}}" href="{{isPreview ? content.moreLink: content.morePage}}">MORE >></a>
                {{/if}}
            </div>

    </div>
    {{/if}}
    <div class="sk-cms-image-text-list-wap sk-cms-detail-dom {{basic.columns.type}}"> <!--column2 column3 column4 一二三四列-->
    {{each content.items}}
        <div class="item {{style.lineStyle.model != 'hide' ? 'border-'+ style.lineStyle.line : ''}} {{basic.style.type}}" style="border-color: {{style.lineStyle.color}};"><!--layout-img-top上下类型  layout-img-left左图右文 layout-img-right右图左文 layout-img-no无图类型 layout-img-under底图上文-->
        {{if $value.linkType != 'none' && isPreview && !isDesign}}
             {{if content.type == 1}}
                 <a class="content-link goto-link" target="_blank" href="{{$value.link}}">
             {{else}}
                 {{if $value.useLinkUrl == 1}}
                       <a class="content-link" href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">
                  {{else}}
                       {{if $value.id}}
                           <a class="content-link goto-link" target="_blank" sk-prop.href="$data.articleDetail + '&aid=' + {{$value.id}}">
                       {{else}}
                           <a class="content-link goto-link" target="_blank" sk-prop.href="$data.articleDetail">
                       {{/if}}
                  {{/if}}
             {{/if}}
        {{/if}}
        {{if $value.linkType != 'none' && !isPreview && !isDesign}}
            {{if $value.useLinkUrl == 1}}
                <a class="content-link" href="javascript:void(0)" sk-event.click="goOuter('{{$value.link}}','{{$value.id}}','{{$value.title}}')">
             {{else}}
                <a class="content-link goto-link" target="_blank" href="{{$value.link}}">
             {{/if}}
        {{/if}}
            <img src="{{$value.imgUrl? $value.imgUrl: '../../assets/images/img_default.jpg'}}" alt="" cms-smarket>
            {{if style.titleStyle.styleType != 'hide' || style.descStyle.styleType != 'hide' || style.timeStyle.styleType != 'hide'}}
            <div class="info {{(basic.style.type == 'layout-img-top' || basic.style.type == 'layout-img-no') && style.timeStyle.styleType == 'hide'? 'no-bottom': ''}}">
                {{if style.titleStyle.styleType != 'hide'}}
                <div class="title {{style.titleStyle.styleType == 'default'?'medium':style.titleStyle.fontSize}}"
                    style="{{style.titleStyle.styleType == 'default' ? '': 'color:' + style.titleStyle.color}}">
                    {{$value.title}}
                </div>
                {{/if}}
                {{if style.descStyle.styleType != 'hide'}}
                <div class="desc {{style.descStyle.styleType == 'default'?'medium':style.descStyle.fontSize}}"
                     style="{{style.descStyle.styleType == 'default' ? '' : 'color:' + style.descStyle.color}}">
                    {{$value.desc}}
                </div>
                {{/if}}
                {{if style.timeStyle.styleType != 'hide'}}
                     <span class="time {{style.timeStyle.styleType == 'default'?'medium':style.timeStyle.fontSize}}"
                                          style="{{style.timeStyle.styleType == 'default' ? '' : 'color:' + style.timeStyle.color}}">{{$value.pushTime}}</span>
                {{/if}}
            </div>
            {{/if}}
        {{if $value.linkType != 'none' && !isDesign}}
            </a>
        {{/if}}
        </div>
    {{/each}}
    </div>
    {{/if}}
    {{if isMain == 1}}
        <% include('../common/pagination.art') %>
    {{/if}}
</div>
